import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setJSDWidgetReady } from "src/store/jsdWidget/actions";

const JSD_SCRIPT_ID = "jsd-widget-script";
const JSD_IFRAME_ID = "jsd-widget";
const JSD_KEY = process.env.REACT_APP_JSD_WIDGET_KEY;
const JSD_BASE_URL = "https://jsd-widget.atlassian.com";

const useJSDWidget = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!JSD_KEY || document.getElementById(JSD_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = JSD_SCRIPT_ID;
    script.setAttribute("data-jsd-embedded", "");
    script.setAttribute("data-key", JSD_KEY);
    script.setAttribute("data-base-url", JSD_BASE_URL);
    script.src = `${JSD_BASE_URL}/assets/embed.js`;
    // embed.js initializes on DOMContentLoaded, which has already fired by
    // the time React mounts. Re-dispatching it triggers embed.js's listener.
    script.addEventListener("load", () => {
      document.dispatchEvent(new Event("DOMContentLoaded"));
    });
    document.head.appendChild(script);

    const pollForIframe = setInterval(() => {
      const iframe = document.getElementById(JSD_IFRAME_ID);
      if (!iframe) {
        return;
      }
      const iframeDoc =
        iframe.contentDocument ||
        (iframe.contentWindow && iframe.contentWindow.document);
      if (!iframeDoc || !iframeDoc.body) {
        return;
      }

      clearInterval(pollForIframe);
      dispatch(setJSDWidgetReady());

      new MutationObserver(() => {
        const helpButton = iframeDoc.querySelector("#help-button");
        if (helpButton && helpButton.style.display !== "none") {
          helpButton.style.display = "none";
        }
      }).observe(iframeDoc.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }, 200);

    return () => clearInterval(pollForIframe);
  }, [dispatch]);
};

export default useJSDWidget;
